import axios from "axios"
import { useCallback, useEffect, useState } from "react"
import { AuthResponse } from "../types"

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '/',
    timeout: 10000,
    headers:{
        'Content-type':'application/json'
    }
})

export const useAuth = () => {

    const [responseData, setResponseData] = useState<AuthResponse | null> (null)

    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string>('')

    useEffect(() =>{
        const storedTokens = localStorage.getItem('authToken')
        if (storedTokens){
            try {
                const tokens: AuthResponse = JSON.parse(storedTokens)
                setResponseData(tokens)
            } catch (error) {
                console.error('Ошибка загрузки токенов ', error)
                localStorage.removeItem('authToken')
            }
        }
    },[])

    const saveTokens = useCallback((tokens: AuthResponse) =>{
        setResponseData(tokens)
        localStorage.setItem('authToken', JSON.stringify(tokens))
    },[])

    const submitRequest = useCallback(async(login:string, password: string) => {
        if(!login.trim() && !password.trim()){
            setError('Не все данные заполнены!')
            return false
        }

        setIsLoading(true)
        setError('')
        setResponseData(null)

        try {
            const response = await api.post('/auth/login',{login, password})
            const tokens: AuthResponse = {

                accessToken: response.data.accessToken,
                refreshToken: response.data.refreshToken
            }
            saveTokens(tokens)
            return true 
        } catch (error:any) {
            console.error('Ошибка отправки данных: ', error.response?.data || error.message )
            setResponseData(null)
            return false
        }finally{
            setIsLoading(false)
        }
    },[setResponseData, saveTokens])

    return{
        responseData, 
        isLoading,
        error,
        submitRequest,
    }
}

